export default {
  common: {
    projectList: "Projektliste",
    pleaseInputProjectName: "Bitte Projektnamen eingeben",
    pipeline: "Pipeline",
    onhold: "Aufgeschoben",
    win: "Gewonnen",
    loss: "Verloren",
    city: "Stadt",
    amount: "Betrag",
    winProbability: "Gewinnwahrscheinlichkeit",
    registeredOn: "Registriert am",
    updatedOn: "Aktualisiert am",
    thereAreNoMoreProjectsLeft: "Es sind keine weiteren Projekte mehr vorhanden",

    drafting: "Entwurf",
    ready: "Bereit",
    shared: "Geteilt",
    negotiating: "Verhandeln",
    secured: "Gesichert",
    lost: "Verloren",
    onhold: "In Wartestellung",

    INITIAL: "ECM-Bericht wird vorbereitet",
    ECM_REPORT_PREPARED: "ECM-Bericht wartet auf gemeinsame Nutzung mit dem Kunden",
    ECM_TO_CUSTOMER: "ECM-Bericht an den Kunden gesendet",
    CUSTOMER_KIV_PROPOSAL: "Kunde behält Vorschlag im Auge",
    CUSTOMER_FUNDED: "Kunde hat Projektfinanzierung bestätigt",
    CUSTOMER_PROPOSAL: "Kunde verhandelt über Vorschlag",
    EA_TO_CUSTOMER: "EA-Bericht an den Kunden gesendet",
    CUSTOMER_ORDERS: "Kundenbestellungen",
    LOST_TO_COMPETITION: "An die Konkurrenz verloren",
    STATUS_PROJECT: "Status in einem anderen Projekt gemeldet",
    IN_ACTIVE: "Projekt aufgeschoben",
    getProjectInfoFailed: "Abruf von Projektinformationen fehlgeschlagen",
    getCitylistFailed: "Abruf der StädteListe fehlgeschlagen",
    cantGetProjectDetails: "Kann Projektdetails nicht abrufen",
    noProjectId: "Keine Projekt-ID",
    noProjectState: "Kein Projektstatus",
    enterProjectName: "Projektname eingeben",

    noActualEcmQuoted: "Kein ECM angegeben"
  },
  projectDlg: {
    newProject: "Neues Projekt",
    projectName: "Projektname",
    projectState: "Projektstatus",
    customer: "Kunde",
    address: "Adresse",
    customerEmail: "Kunden-E-Mail",
    auditDate: "Prüfdatum",
    jobsiteCity: "Baustellenstadt",
    estimatedEcmQuoted: "Geschätztes ECM-Angebot",
    exceptedOrder: "Voraussichtliches Bestelldatum",
    winProbability: "Gewinnwahrscheinlichkeit %",
    saveRetrun: "Speichern & Zurück",
    saveAudit: "Speichern & Prüfen",
    statusRemarks: "Bemerkungen zum Status",

    actualEcmQuoted: "Tatsächlicher ECM",
    actualOrder: "Tatsächlicher Bestelltermin"
  }
}



// WEBPACK FOOTER //
// ./src/locale/projectList/de.js